import { render, staticRenderFns } from "./SelectUsuario.vue?vue&type=template&id=38ca6964&scoped=true"
import script from "./SelectUsuario.vue?vue&type=script&lang=js"
export * from "./SelectUsuario.vue?vue&type=script&lang=js"
import style0 from "./SelectUsuario.vue?vue&type=style&index=0&id=38ca6964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca6964",
  null
  
)

export default component.exports